import { FC, ReactNode } from "react";

import { SuggestionChip } from "./SuggestionChip";
import { Body, Title } from "../../../typography";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly introTitle: ReactNode;
  readonly introSubtitle: ReactNode;
  readonly introPresets?: readonly string[];
  readonly currentInputValue: string;
  readonly onPresetSelect: (preset: string) => void;
}

/** Empty-state view shown before any messages exist, with optional preset question chips. */
export const EmptyState: FC<Props> = ({
  styles,
  introTitle,
  introSubtitle,
  introPresets,
  currentInputValue,
  onPresetSelect,
}) => (
  <div className={styles.EmptyState}>
    <Title textAlign="center">{introTitle}</Title>
    <Body>{introSubtitle}</Body>
    {!!introPresets && introPresets.length > 0 && (
      <div className={styles.EmptyStatePresets}>
        {introPresets.map((preset, index) => (
          <SuggestionChip
            key={`${preset}::${index}`}
            styles={styles}
            label={preset}
            disabled={currentInputValue === preset}
            onSelect={onPresetSelect}
          />
        ))}
      </div>
    )}
  </div>
);
